// removed by extract-text-webpack-plugin
module.exports = {"bg":"rgba(14,106,180,.9)","color":"#fff","hover":"rgba(56,66,76,.9)","active":"#ffd04b","btnColor":"primary"};


//////////////////
// WEBPACK FOOTER
// ./src/dzy/assets/css/global.scss
// module id = X/pg
// module chunks = 43